import React from 'react';
export const Vega = React.lazy(() => import(/* webpackChunkName: "Vega" */ './fragments/Vega.react'));